
/**
 * 리뷰 태그
 */
export interface ReviewTag {
  /** 사용 횟수 */
  count: number;
  /** 태그 이름 */
  name: string;
}
